/**
 * The backend uses ui-avatars.com as the avatar fallback, without a `format`
 * param. ui-avatars serves some of those URLs as SVG, and Cloudflare caches
 * whichever variant was rendered first per URL for a year — browsers display
 * SVG in <img> fine (web unaffected), but React Native's <Image> can't decode
 * SVG, so those avatars silently error into a grey circle on native.
 *
 * Pinning `format=png` both forces a rasterized response and changes the
 * cache key, sidestepping the already-cached SVG variants.
 */
export function fixAvatarUrl(url: string): string;
export function fixAvatarUrl(url: string | undefined): string | undefined;
export function fixAvatarUrl(url: string | undefined): string | undefined {
    if (url && url.includes('ui-avatars.com') && !/[?&]format=/.test(url)) {
        return `${url}${url.includes('?') ? '&' : '?'}format=png`;
    }
    return url;
}
